/**Swiper**/

var swiperFull = new Swiper(".galleryFull", {
	/*init: false,*/
	spaceBetween: 30,
    slidesPerView: 1,
	speed:500,
	loop: true,
	navigation: {
		prevEl: ".swiper-button-prev",
		nextEl: ".swiper-button-next",
	},
	breakpoints: {
		0: {
			spaceBetween: 5,
			slidesPerView: 1,
		},
		768: {
			spaceBetween: 5,
			slidesPerView: 1,
		},
		1024: {
			spaceBetween: 5,
			slidesPerView: 2,
		},
		1450: {
			spaceBetween: 5,
			slidesPerView: 4,
		},
	},
});

var swiperFull = new Swiper(".galleryText", {
	/*init: false,*/
	spaceBetween: 30,
    slidesPerView: 1,
	speed:500,
	loop: true,
	navigation: {
		prevEl: ".swiper-button-prev",
		nextEl: ".swiper-button-next",
	},
	breakpoints: {
		0: {
			spaceBetween: 5,
			slidesPerView: 1,
		},
		768: {
			spaceBetween: 5,
			slidesPerView: 1,
		},
		1024: {
			spaceBetween: 30,
			slidesPerView: 2,
		},
		1450: {
			spaceBetween: 60,
			slidesPerView: 3,
		},
	},
});


/**Scroller**/

const scrollers = document.querySelectorAll(".scroller");

addAnimation();

function addAnimation() {
  scrollers.forEach((scroller) => {

	scroller.setAttribute("data-animated", true);

    const scrollerInner = scroller.querySelector(".scroller-inner");
    const scrollerContent = Array.from(scrollerInner.children);

	scrollerContent.forEach((item) => {
      const duplicatedItem = item.cloneNode(true);
      duplicatedItem.setAttribute("aria-hidden", true);
      scrollerInner.appendChild(duplicatedItem);
    });
  
  });

}


/**Accordion**/

const accordions = document.querySelectorAll(".accordion");

const openAccordion = (accordion) => {
	const content = accordion.querySelector(".accordion-content");
	accordion.classList.add("accordion-active");
	content.style.maxHeight = (content.scrollHeight + 60) + "px";
};

const closeAccordion = (accordion) => {
	const content = accordion.querySelector(".accordion-content");
	accordion.classList.remove("accordion-active");
	content.style.maxHeight = null;
};

accordions.forEach((accordion) => {
	
	const intro = accordion.querySelector(".accordion-intro");
	const content = accordion.querySelector(".accordion-content");

	intro.onclick = () => {
		if (content.style.maxHeight) {
			closeAccordion(accordion);
		} else {
			accordions.forEach((accordion) => closeAccordion(accordion));
			openAccordion(accordion);
		}
	};
});

/**Menu**/

const body = document.querySelector('body');
const ctaMobile = document.querySelectorAll('.hamburger');

ctaMobile.forEach(function(element) {

element.addEventListener('click', function () {
		
	if (body.classList.contains('openMenu')) {
		
		body.classList.remove('openMenu');
		body.classList.add('closeMenu');	
		
	} else {
		
		body.classList.add('openMenu');
		body.classList.remove('closeMenu');
	}
		
});
	
});


/**loading and transition**/

document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelector('body').style.opacity = 1;
});

/**Dynamic attr img title and alt**/

const pageTitle = document.title, imgAdd = document.querySelectorAll("img");

imgAdd.forEach(function(el) {
	el.setAttribute('title', pageTitle);
	el.setAttribute('alt', pageTitle);
});

/**disable right click and image draggable**/

const noClick = document.querySelectorAll("img"); 
noClick.forEach(function(el) {
	el.addEventListener("contextmenu", (event) => { event.preventDefault();});
	el.setAttribute('draggable', 'false');
});
